import AboutXpKnowMoreDialog from './AboutXpKnowMoreDialog';

const FALLBACK_CONTENT = {
  title: 'Know About RapCoins',
  sections: [
    {
      heading: 'What are RapCoins?',
      body:
        'RapCoins are an in-app virtual currency that let you unlock entry to play the games on Rapchik. They are designed to enhance your experience by giving you more ways to interact, earn rewards and participate within the platform.',
    },
    {
      heading: 'How to Get RapCoins?',
      body:
        'You can earn RapCoins by completing activities such as daily logins and challenges. RapCoins can also be obtained through the app during special offers or anytime from the coin store. Moreover, you may get RapCoins by converting your XPs.',
    },
    {
      heading: 'How to Use RapCoins?',
      body:
        'Use RapCoins to unlock your game entry or participate in exclusive events. Simply choose an option that requires RapCoins and confirm your entry within the game.',
    },
  ],
};

/** Figma 11051:14896–14908 — Know About RapCoins dialog */
export default function RapCoinKnowMoreDialog({ open, onClose }) {
  return <AboutXpKnowMoreDialog open={open} onClose={onClose} slug="rapCoins" fallbackContent={FALLBACK_CONTENT} />;
}
